// extracted by mini-css-extract-plugin
export default {"htmlContent":"ufaOlb","description":"Va_ZoC","content":"skK8UF","descriptionWrapper":"LvOu6J","title":"wHdJFH","contentWrapper":"vaI0UH","showMoreOrLess":"guYvjy"};